"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var UIUtils_1 = require("../../../../../../../../shared/modules/UIUtils");
var ToolBarButtonsOnly_1 = require("../../../../../../../../shared/components/toolbars/ToolBarButtonsOnly");
var notificationHelper_1 = require("../../../../../../../../shared/helpers/notificationHelper");
var ToolBarDateRangeFilter_1 = require("../../../../../../../../shared/components/toolbars/ToolBarDateRangeFilter");
var PlayerDepositsList = /** @class */ (function (_super) {
    __extends(PlayerDepositsList, _super);
    function PlayerDepositsList(props) {
        var _this = _super.call(this, props) || this;
        _this.columns = [
            {
                title: 'Дата',
                dataIndex: _this.props.dataFinance.dk_date_added,
                key: _this.props.dataFinance.dk_date_added,
                render: function (text, record, idx) {
                    return (React.createElement("div", null, record.date_added.format(_this.state.dtFormat)));
                },
                width: 220,
            }, {
                title: 'Бренд',
                dataIndex: _this.props.dataFinance.dk_brand_title,
                key: _this.props.dataFinance.dk_brand_title,
                width: 150,
            }, {
                title: 'Игрок',
                dataIndex: _this.props.dataFinance.dk_player_login,
                key: _this.props.dataFinance.dk_player_login,
                width: 150,
            }, {
                title: 'Основание',
                dataIndex: _this.props.dataFinance.dk_deposit_basis_title,
                key: _this.props.dataFinance.dk_deposit_basis_title,
                width: 180,
            }, {
                title: 'Тип',
                dataIndex: _this.props.dataFinance.dk_deposit_type_title,
                key: _this.props.dataFinance.dk_deposit_type_title,
                width: 150,
            }, {
                title: 'Провайдер',
                dataIndex: _this.props.dataFinance.dk_raw_gws_title,
                key: _this.props.dataFinance.dk_raw_gws_title,
                width: 150,
                render: function (text, record, idx) {
                    return (React.createElement("div", null,
                        record.raw_gws_title,
                        "/",
                        record.raw_prv_title));
                },
            }, {
                title: 'Сумма',
                dataIndex: _this.props.dataFinance.dk_amount_in_deposit_currency_without_comission,
                key: _this.props.dataFinance.dk_amount_in_deposit_currency_without_comission,
                width: 200,
                render: function (text, record, idx) {
                    return (React.createElement("div", null,
                        UIUtils_1.UIUtils.formatCurrency(record.amount_in_player_currency_without_comission),
                        " ",
                        record.player_currency_title));
                }
            }, {
                title: 'Промокод.',
                dataIndex: _this.props.dataFinance.dk_promo_code_code,
                key: _this.props.dataFinance.dk_promo_code_code,
                width: 180,
                render: function (text, record, idx) {
                    return (React.createElement("div", null, record.promo_code_code));
                }
            }, {
                title: 'Бонус',
                dataIndex: _this.props.dataFinance.dk_active_bonus_id,
                key: _this.props.dataFinance.dk_active_bonus_id,
                width: 150,
                render: function (text, record, idx) {
                    return (React.createElement("div", null, record.active_bonus_title));
                }
            }, {
                title: 'Статус',
                dataIndex: _this.props.dataFinance.dk_deposit_state_title,
                key: _this.props.dataFinance.dk_deposit_state_title,
                width: 150,
            }
        ];
        return _this;
    }
    PlayerDepositsList.prototype.getDataOffset = function () {
        return (this.state.pageNum - 1) * this.state.pageSize;
    };
    PlayerDepositsList.prototype.componentWillMount = function () {
        var _this = this;
        this.SID = this.props.dataFinance.Subscribe("*", function (id, data) {
            _this.setState({
                data: data.data,
                totalRows: data.total
            });
        });
        this.SID_STATE = this.props.state.Subscribe("*", function (id, data) {
            _this.setState({
                dtFrom: data.dtFrom,
                dtTo: data.dtTo,
                dtFormat: data.dtTimeFormat
            }, function () {
                _this.loadData(_this.props);
            });
        });
        this.setState({
            data: this.props.dataFinance.DATA.data,
            pageNum: this.props.pageNum,
            pageSize: this.props.pageSize,
            totalRows: 0,
            dtFrom: this.props.state.getDateFrom(),
            dtTo: this.props.state.getDateTo(),
            dtFormat: this.props.state.getDateTimeFormat()
        }, function () {
            _this.loadData(_this.props);
        });
    };
    PlayerDepositsList.prototype.componentWillUnmount = function () {
        this.props.dataFinance.UnSubscribe(this.SID);
        this.props.state.UnSubscribe(this.SID_STATE);
    };
    PlayerDepositsList.prototype.componentWillReceiveProps = function (nextProps) {
        var _this = this;
        if (nextProps) {
            this.setState({
                pageNum: nextProps.pageNum,
                pageSize: nextProps.pageSize,
            }, function () {
                _this.loadData(nextProps);
            });
        }
    };
    PlayerDepositsList.prototype.loadData = function (Props, onDone) {
        Props.dataFinance.LoadRangeDataByPlayerId({
            playerId: this.props.player.key,
            Offset: this.getDataOffset(),
            Limit: this.state.pageSize,
            from_year: this.state.dtFrom.get('year'),
            from_month: this.state.dtFrom.get('month') + 1,
            from_day: this.state.dtFrom.get('date'),
            from_hour: this.state.dtFrom.get('hour'),
            from_minute: this.state.dtFrom.get('minute'),
            to_year: this.state.dtTo.get('year'),
            to_month: this.state.dtTo.get('month') + 1,
            to_day: this.state.dtTo.get('date'),
            to_hour: this.state.dtTo.get('hour'),
            to_minute: this.state.dtTo.get('minute'),
        }, function () {
            if (onDone) {
                onDone();
            }
        });
    };
    PlayerDepositsList.prototype.onPageChanged = function (Page, PageSize) {
        var _this = this;
        var _page = Page;
        if (PageSize != this.state.pageSize) {
            _page = 1;
        }
        this.setState({ pageNum: _page, pageSize: PageSize }, function () {
            _this.loadData(_this.props, function () {
                if (_this.props.onPageConfigChanged) {
                    _this.props.onPageConfigChanged(_page, PageSize);
                }
            });
        });
    };
    PlayerDepositsList.prototype.onToolBarClick = function (action) {
        var _this = this;
        if (action === "refresh") {
            this.loadData(this.props);
        }
        if (action === "create") {
            this.props.dlgFinance
                .clearFields()
                .SetTitle("Пополнить баланс игрока")
                .SetCurrencyTitle(this.props.player.app_currency_title)
                .SetDescriptionVisibility(true)
                .SetTagVisibility(true)
                .SetOnYesClick(function (amount, description, tag) {
                _this.props.dataPlayers.doDepositMoneyToPlayer(_this.props.player.key, amount, description, tag, function () {
                    notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                        "\u0411\u0430\u043B\u0430\u043D\u0441 \u0438\u0433\u0440\u043E\u043A\u0430 ",
                        React.createElement("b", null,
                            "[",
                            _this.props.player.login,
                            "]"),
                        " \u043F\u043E\u043F\u043E\u043B\u043D\u0435\u043D \u043D\u0430 \u0441\u0443\u043C\u043C\u0443 ",
                        React.createElement("b", null,
                            "[",
                            amount,
                            "]"),
                        " ",
                        React.createElement("b", null, _this.props.player.app_currency_title),
                        " !"));
                    _this.loadData(_this.props);
                });
            }).Show();
        }
        if (action === "back") {
            if (this.props.onGoBackClick) {
                this.props.onGoBackClick();
            }
        }
    };
    PlayerDepositsList.prototype.onSelectRange = function (DtFrom, DtTo) {
        this.props.state.setDateFrom(DtFrom).setDateTo(DtTo, true);
    };
    PlayerDepositsList.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(ToolBarButtonsOnly_1.default, { hint: { refresh: "Обновить", create: "Пополнить", back: "Назад" }, onClick: this.onToolBarClick.bind(this) },
                React.createElement(ToolBarDateRangeFilter_1.default, { title: "\u0414\u0438\u0430\u043F\u0430\u0437\u043E\u043D \u0434\u0430\u0442: ", from: { date: this.state.dtFrom, title: "Начало" }, to: { date: this.state.dtTo, title: "Окончание" }, onClick: this.onSelectRange.bind(this) })),
            React.createElement(antd_1.Table, { locale: {
                    filterTitle: 'Поиск',
                    filterConfirm: 'Да',
                    filterReset: 'Сброс',
                    emptyText: 'Нет данных',
                }, bordered: true, columns: this.columns, dataSource: this.state.data, pagination: {
                    pageSize: this.state.pageSize,
                    showSizeChanger: true,
                    current: this.state.pageNum,
                    total: this.state.totalRows,
                    position: "bottom",
                    onChange: this.onPageChanged.bind(this),
                    onShowSizeChange: this.onPageChanged.bind(this),
                    pageSizeOptions: this.props.state.UITablePageSizeOptions,
                    showQuickJumper: true,
                }, footer: function (data) {
                    return React.createElement("div", null,
                        "\u041E\u0442\u043E\u0431\u0440\u0430\u0436\u0430\u0435\u0442\u0441\u044F \u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435 : ",
                        data.length,
                        " \u0438\u0437 ",
                        _this.state.totalRows,
                        " \u0437\u0430\u043F\u0438\u0441\u0435\u0439");
                }, expandedRowRender: function (record) {
                    return (React.createElement("div", null,
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0418\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440 \u0437\u0430\u043F\u0438\u0441\u0438:"),
                            " [",
                            record.key,
                            "] "),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0421\u043E\u0437\u0434\u0430\u043D:"),
                            " [",
                            record.date_added.format(_this.state.dtFormat),
                            "] "),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0418\u0437\u043C\u0435\u043D\u0435\u043D:"),
                            " [",
                            record.date_changed.format(_this.state.dtFormat),
                            "]"),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0411\u0430\u043B\u0430\u043D\u0441 \u0434\u043E:"),
                            " [",
                            record.player_balance_before,
                            "]"),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0411\u0430\u043B\u0430\u043D\u0441 \u043F\u043E\u0441\u043B\u0435:"),
                            " [",
                            record.player_balance_after,
                            "]"),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u041A\u043E\u043C\u043C\u0435\u043D\u0442\u0430\u0440\u0438\u0439:"),
                            " [",
                            record.description,
                            "]"),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u041A\u0443\u0440\u0441 \u043E\u0431\u043C\u0435\u043D\u0430 (\u0434\u0435\u043F\u043E\u0437\u0438\u0442 - \u0438\u0433\u0440\u043E\u043A):"),
                            " [",
                            record.exchange_rate_deposit_to_player,
                            "]")));
                } })));
    };
    return PlayerDepositsList;
}(React.Component));
exports.default = PlayerDepositsList;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/main_players_list/ui/component/operations/deposit/PlayerDepositsList.tsx
// module id = 1922
// module chunks = 0